/**
 * Caps text at `lines` lines with an ellipsis, and lets long unbroken words (URLs, file names)
 * wrap instead of stretching their card and the page.
 */
export const clampLines = (lines: number) => ({
    display: "-webkit-box",
    WebkitLineClamp: lines,
    WebkitBoxOrient: "vertical" as const,
    overflow: "hidden",
    overflowWrap: "anywhere" as const,
})
